import { Box, Divider } from '@mui/material';
import { BarLoader } from 'react-spinners';

const AnimatedDivider = ({ loading }: { loading: boolean }) => (
  <Box
    sx={{
      position: 'relative',
      height: 2,
      mb: 1,
      width: '100%',
    }}
  >
    <Divider sx={{
      borderStyle: 'dashed',
    }}
    />

    {loading && (
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'transparent',
          pointerEvents: 'none',
        }}
      >
        <BarLoader
          height={2}
          width="100%"
          color="#b976f8"
          loading
        />
      </Box>
    )}
  </Box>
);

export {
  AnimatedDivider,
};
